import React from 'react'
import './PolicyEndorsements.scss'

export default function PolicyEndorsements({ endorsements, originalPolicy, onPolicyDownload, onEndorsementDownload }) {
  return (
    <div className="policy-endorsements-container">
      <div className="policy-endorsements-title">PolicyEndorsements</div>
      <div className="policy-endorsement">
        <div>
          <div className="policy-endorsements-body-title">Original Policy</div>
          <div className="policy-endorsements-body-dates">
            Dates: {originalPolicy.valid_from} - {originalPolicy.valid_to}
          </div>
        </div>
        <div className="policy-endorsements-view">
          <div onClick={onPolicyDownload}>View</div>
        </div>
      </div>
      {endorsements.map((endorsement, index) => (
        <div key={endorsement.id} className="policy-endorsement">
          <div>
            <div className="policy-endorsements-body-title">
              Policy Endorsement #{index + 1}
              {index === endorsements.length - 1 && ' (Current)'}
            </div>
            <div className="policy-endorsements-body-dates">Endorsement Date: {endorsement.effective_date}</div>
          </div>
          <div className="policy-endorsements-view">
            <div onClick={() => onEndorsementDownload(endorsement.id)}>View</div>
          </div>
        </div>
      ))}
    </div>
  )
}
